import React from 'react';
import { Link, navigate, StaticQuery, graphql } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { withMixpanel } from 'gatsby-plugin-mixpanel';
import { Squash as Hamburger } from 'hamburger-react';
import classnames from 'classnames';

import OktetoLogo from '../assets/logo-horizontal-darkbg.svg';
import OktetoLogoLight from '../assets/logo-horizontal-lightbg.svg';
import ExploreDeployIcon from '../assets/explore-deploy.svg';
import BuildDevExperienceIcon from '../assets/build-dev-experience.svg';
import ExploreDevelopIcon from '../assets/explore-develop.svg';
import ExplorePreviewIcon from '../assets/explore-previews.svg';
import ExplorePlatform from '../assets/explore-platform.svg';
import ExploreTestIcon from '../assets/explore-test.svg';

import './Header.scss';

const normalizePathname = (path) => path.replace(/\/$/, '');

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFeatures: false,
      showResources: false,
      openForMobile: false,
      showHighlight: false,
      currentPath: '',
    };
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined' && window.document) {
      document.removeEventListener('mousedown', this.handleOutsideHintClick);
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.setState({
        showHighlight:
          window.sessionStorage.getItem('showHighlight') !== 'false',
      });
      this.setState({ currentPath: window.location.pathname });
    }
  }

  handleOutsideHintClick = (e) => {
    if (this.announcementBar && this.announcementBar.contains(e.target)) return;

    if (this.submenu && !this.submenu.contains(e.target)) {
      this.hideAllSubmenu();
    }

    if (
      this.menu &&
      !this.menu.contains(e.target) &&
      this.burger &&
      !this.burger.contains(e.target)
    ) {
      this.hideMobileMenu();
    }
  };

  goToApp() {
    this.props.mixpanel.track('Click Start App');
    window.location.href = 'https://cloud.okteto.com';
  }

  hideAllSubmenu() {
    this.setState({ showFeatures: false, showResources: false });
    if (typeof window !== 'undefined' && window.document) {
      window.document.removeEventListener(
        'mousedown',
        this.handleOutsideHintClick
      );
    }
  }

  hideMobileMenu() {
    this.setState({ openForMobile: false });
    if (typeof window !== 'undefined' && window.document) {
      window.document.removeEventListener(
        'mousedown',
        this.handleOutsideHintClick
      );
    }
  }

  toogleFeatures() {
    this.setState({
      showFeatures: !this.state.showFeatures,
      showResources: false,
    });

    if (typeof window !== 'undefined' && window.document) {
      window.document.addEventListener(
        'mousedown',
        this.handleOutsideHintClick
      );
    }
  }

  toggleResources() {
    this.setState({
      showResources: !this.state.showResources,
      showFeatures: false,
    });

    if (typeof window !== 'undefined' && window.document) {
      window.document.addEventListener(
        'mousedown',
        this.handleOutsideHintClick
      );
    }
  }

  dismissToast() {
    sessionStorage.setItem('showHighlight', false);
    this.setState({ showHighlight: false });
  }

  renderMenuLinks() {
    const { location } = this.props;
    const { showFeatures, showResources, openForMobile } = this.state;
    const path = location ? normalizePathname(location.pathname) : null;

    return (
      <>
        <li>
          <button onClick={() => this.toogleFeatures()}>Product</button>
          {(showFeatures || openForMobile) && (
            <div className="Submenu">
              <div className="SubmenuArrow" />
              <ul className="SubmenuContent SubmenuContentWithIcons">
                <li onClick={() => navigate('/development-environments/')}>
                  <ExploreDeployIcon className="SubmenuIcon" />
                  <div className="layout vertical">
                    <Link to="/development-environments/">
                      Development Environments
                    </Link>
                    <div className="SubmenuDescription">
                      Modern, Realistic, Self-service on K8s
                    </div>
                  </div>
                </li>
                <li onClick={() => navigate('/preview-environments/')}>
                  <ExplorePreviewIcon className="SubmenuIcon" />
                  <div className="layout vertical">
                    <Link to="/preview-environments/">
                      Preview Environments
                    </Link>
                    <div className="SubmenuDescription">
                      Shareable environments with every pull request
                    </div>
                  </div>
                </li>
                <li
                  onClick={() => navigate('/streamlined-kubernetes-testing/')}
                >
                  <ExploreTestIcon className="SubmenuIcon" />
                  <div className="layout vertical">
                    <Link to="/streamlined-kubernetes-testing/">Test</Link>
                    <div className="SubmenuDescription">
                      Run tests directly in your development environments
                    </div>
                  </div>
                </li>
                <li onClick={() => navigate('/platform-features/')}>
                  <ExplorePlatform className="SubmenuIcon" />
                  <div className="layout vertical">
                    <Link to="/platform-features/">Platform Features</Link>
                    <div className="SubmenuDescription">
                      Okteto Experience features and benefits
                    </div>
                  </div>
                </li>
                <li onClick={() => navigate('/automate-dev-on-k8s/')}>
                  <BuildDevExperienceIcon className="SubmenuIcon" />
                  <div className="layout vertical">
                    <Link to="/automate-dev-on-k8s/">
                      Build Development Experiences
                    </Link>
                    <div className="SubmenuDescription">
                      Development experiences for your entire team
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </li>
        <li>
          <Link to="/pricing/">Pricing</Link>
        </li>
        <li>
          <Link to="/customers/">Customers</Link>
        </li>
        <li>
          <OutboundLink href="/docs/welcome/overview/">Docs</OutboundLink>
        </li>
        <li>
          <Link to="/blog/">Blog</Link>
        </li>
        <li>
          <button onClick={() => this.toggleResources()}>Resources</button>
          {(showResources || openForMobile) && (
            <div className="Submenu">
              <div className="SubmenuArrow" />
              <ul className="SubmenuContent">
                <li onClick={() => navigate('/product-tour-center/')}>
                  <div className="layout vertical">
                    <Link to="/product-tour-center/">Demo Center</Link>
                  </div>
                </li>
                <li onClick={() => navigate('/videos/')}>
                  <div className="layout vertical">
                    <Link to="/videos/">Videos</Link>
                  </div>
                </li>
                <li onClick={() => navigate('/videos/tutorials/')}>
                  <div className="layout vertical">
                    <Link to="/videos/tutorials/">Tutorials</Link>
                  </div>
                </li>
                <li onClick={() => navigate('/videos/webinars/')}>
                  <div className="layout vertical">
                    <Link to="/videos/webinars/">Webinars</Link>
                  </div>
                </li>
                <li onClick={() => navigate('/devx-principles/')}>
                  <div className="layout vertical">
                    <Link to="/devx-principles/">DevX Principles </Link>
                  </div>
                </li>
                <li onClick={() => navigate('/build-versus-buy/')}>
                  <div className="layout vertical">
                    <Link to="/build-versus-buy/">Build v. Buy</Link>
                  </div>
                </li>
                <li onClick={() => navigate('/ebooks-and-guides/')}>
                  <div className="layout vertical">
                    <Link to="/ebooks-and-guides/">eBooks and Guides</Link>
                  </div>
                </li>
                <li onClick={() => navigate('https://community.okteto.com')}>
                  <div className="layout vertical">
                    <OutboundLink href="https://community.okteto.com">
                      Community
                    </OutboundLink>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </li>
      </>
    );
  }

  renderLoginLinks() {
    return (
      <>
        <li className="MainMenuAction-cta">
          <a href="/tour/" className="button button-secondary">
            Take a tour
          </a>
        </li>
        <li className="MainMenuAction-cta">
          <a href="/get-demo/" className="button button-primary">
            Get a demo
          </a>
        </li>
      </>
    );
  }

  render() {
    const { headerColor = null, theme = 'dark', mixpanel } = this.props;
    const { openForMobile, showHighlight, currentPath } = this.state;

    const announcementBarQuery = graphql`
      query announcementBarQuery {
        sanityAnnouncementBar {
          defaultAnnouncement {
            title
            callToAction {
              url
              label
            }
            image {
              asset {
                url
              }
            }
          }
          scheduledAnnouncement {
            endDateAndTime
            startDateAndTime
            title
            callToAction {
              url
              label
            }
            image {
              asset {
                url
              }
            }
          }
        }
      }
    `;

    const AnnouncementBar = ({ data }) => {
      const currentDateAndTime = new Date().toISOString();

      const { defaultAnnouncement, scheduledAnnouncement } = data;

      let announcementData = defaultAnnouncement;

      if (
        scheduledAnnouncement &&
        currentDateAndTime > scheduledAnnouncement.startDateAndTime &&
        currentDateAndTime < scheduledAnnouncement.endDateAndTime
      ) {
        announcementData = scheduledAnnouncement;
      }

      if (announcementData?.title) {
        return (
          <div
            className={classnames('HeaderHighlight', {
              'HeaderHighlight-show': showHighlight,
            })}
            ref={(e) => (this.announcementBar = e)}
          >
            <div className="HeaderHighlightWrapper">
              <div className="HeaderHighlightContainer">
                <div className="HeaderHighlightContent">
                  <div className="HeaderHighlightTitle">
                    {announcementData.image?.asset?.url && (
                      <img src={announcementData.image?.asset?.url} alt="" />
                    )}
                    {announcementData.title}
                  </div>
                  <a
                    href={announcementData.callToAction?.url}
                    onClick={() =>
                      mixpanel.track('Click Toast Link', {
                        url: announcementData.callToAction?.url,
                      })
                    }
                  >
                    {announcementData.callToAction?.label} →
                  </a>
                </div>
              </div>
              <div
                className="HeaderHighlightClose"
                role="button"
                tabIndex={0}
                onKeyDown={(event) =>
                  event.key === 'Enter' && this.dismissToast()
                }
                onClick={() => this.dismissToast()}
              >
                &#10005;
              </div>
            </div>
          </div>
        );
      }
      return null;
    };

    return (
      <StaticQuery
        query={announcementBarQuery}
        render={(data) => {
          const { sanityAnnouncementBar } = data;
          return (
            <header
              className={classnames('Header', {
                light: theme === 'light',
                open: openForMobile,
                closed: !openForMobile,
              })}
              style={{
                backgroundColor: headerColor || undefined,
              }}
            >
              {currentPath !== '/pricing/' && (
                <AnnouncementBar data={sanityAnnouncementBar} />
              )}

              <div className="HeaderContainer">
                <Link
                  className="logo layout horizontal center"
                  to="/"
                  aria-label="Homepage"
                >
                  {theme !== 'light' && <OktetoLogo size="32" />}
                  {theme === 'light' && <OktetoLogoLight size="32" />}
                </Link>

                <ul
                  className={classnames('MainMenu', {
                    'MainMenu-with-highlight': showHighlight,
                  })}
                  ref={(e) => (this.submenu = e)}
                >
                  {this.renderMenuLinks()}
                </ul>

                <div className="flex-auto" />

                <ul
                  className={classnames('MainMenu MainMenuAction', {
                    'MainMenu-with-highlight': showHighlight,
                  })}
                >
                  {this.renderLoginLinks()}
                </ul>

                <div
                  className="HamburgerContainer"
                  ref={(e) => (this.burger = e)}
                >
                  <Hamburger
                    className="HamburgerButton"
                    size={24}
                    color="white"
                    toggled={openForMobile}
                    toggle={() =>
                      this.setState({ openForMobile: !openForMobile })
                    }
                  />
                </div>
              </div>
              <div className="MobileMenuWrapper" ref={(e) => (this.menu = e)}>
                <div className="MobileMenu">
                  <ul>
                    {this.renderMenuLinks()}
                    {this.renderLoginLinks()}
                  </ul>
                </div>
              </div>
            </header>
          );
        }}
      />
    );
  }
}

export default withMixpanel()(Header);
